/* eslint-disable jira/filename-case */
import {
	APP_BUNDLE_READY,
	PREFETCH_API_READY,
	PREFETCH_API_START,
	JSW_RENDER_START,
	JSW_CREATE_REDUX_STORE_START,
	JSW_CREATE_REDUX_STORE_END,
	JSW_TRANSFORM_CRITICAL_DATA_START,
	JSW_TRANSFORM_CRITICAL_DATA_END,
	JSW_REDUX_SOFTWARE_APP_LOADED_START,
	JSW_REDUX_SOFTWARE_APP_LOADED_END,
} from './constants.tsx';
import { getPrefixedMarkName } from './transform.tsx';

export const appBundleReadyMark: string = getPrefixedMarkName(APP_BUNDLE_READY);
export const prefetchApiReadyMark: string = getPrefixedMarkName(PREFETCH_API_READY);
export const prefetchApiStartMark: string = getPrefixedMarkName(PREFETCH_API_START);

export const jswRenderStartMark: string = getPrefixedMarkName(JSW_RENDER_START);

export const jswCreateReduxStoreStartMark: string = getPrefixedMarkName(
	JSW_CREATE_REDUX_STORE_START,
);
export const jswCreateReduxStoreEndMark: string = getPrefixedMarkName(JSW_CREATE_REDUX_STORE_END);

export const jswTransformCriticalDataStartMark: string = getPrefixedMarkName(
	JSW_TRANSFORM_CRITICAL_DATA_START,
);
export const jswTransformCriticalDataEndMark: string = getPrefixedMarkName(
	JSW_TRANSFORM_CRITICAL_DATA_END,
);

export const jswReduxSoftwareAppLoadedStartMark: string = getPrefixedMarkName(
	JSW_REDUX_SOFTWARE_APP_LOADED_START,
);
export const jswReduxSoftwareAppLoadedEndMark: string = getPrefixedMarkName(
	JSW_REDUX_SOFTWARE_APP_LOADED_END,
);
